module.exports = __webpack_public_path__ + "img/apidays-2022-snapshot-gary-1.53390151.jpg";